export default __webpack_public_path__ + "2eba80634542ca43d56cd043c39cde36.png";